import * as React from 'react'

function GocciaFullColor(props) {
  return (
    <svg
      {...props}
      className={
        'icon icon--strokes icon--gocciafullcolor ' + (props.classes ? ' ' + props.classes : '')
      }
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_619_4710)">
        <mask
          id="mask0_619_4710"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="0"
          width="18"
          height="20"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99355 3.36462L10.6686 4.12462L11.1666 4.69847L11.6436 5.25847L12.0996 5.80616L12.5331 6.33847L12.9441 6.85847L13.3341 7.36616L13.7031 7.85847L14.0481 8.33847L14.3751 8.80616L14.6781 9.26001C14.7756 9.40924 14.8701 9.55539 14.9601 9.70001L15.2211 10.1277L15.3411 10.3369L15.5706 10.7462C15.6066 10.8123 15.6426 10.88 15.6756 10.9462L15.8721 11.3354C17.2926 14.2739 16.8246 16.1 14.5311 16.9739L14.2221 17.0815C13.7421 17.2385 13.1916 17.3569 12.5721 17.44L12.1506 17.4908L11.7066 17.5308L11.2416 17.5615L10.7586 17.5815L10.2531 17.5923H9.99355L9.47755 17.5877L9.22855 17.5815L8.74405 17.5615L8.27905 17.5308L7.83655 17.4908L7.41355 17.44C6.79405 17.3569 6.24355 17.2385 5.76355 17.0831L5.45455 16.9754C3.15955 16.0985 2.69305 14.2723 4.11355 11.3354L4.30855 10.9446L4.41505 10.7446L4.64305 10.3369L4.76605 10.1277L5.02555 9.70001C5.11555 9.55539 5.21005 9.4077 5.30755 9.26001L5.61205 8.80616L5.93605 8.33847L6.28405 7.85847L6.65155 7.36616L7.04155 6.85847L7.45405 6.33847L7.88755 5.80616L8.34205 5.25847L8.81905 4.69847L9.31855 4.12462L9.99355 3.36462Z"
            fill="#131518"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99331 0.5L8.98231 1.60462L8.36731 2.28769L7.78232 2.96L7.21982 3.62154C7.12832 3.72923 7.03682 3.83692 6.94832 3.94615L6.42332 4.58769C6.25382 4.8 6.08882 5.01077 5.92832 5.21846L5.45582 5.83538C5.07332 6.34462 4.71632 6.84154 4.38782 7.32462L4.00682 7.9C3.63782 8.46615 3.30782 9.01538 3.01682 9.54615L2.74082 10.0677C-0.392684 16.1754 1.94282 19.5508 9.99331 19.5508C18.0438 19.5508 20.3778 16.1754 17.2458 10.0677L16.9683 9.54462C16.6773 9.01538 16.3473 8.46769 15.9783 7.89846L15.5973 7.32462C15.2673 6.84154 14.9133 6.34462 14.5308 5.83538L14.0583 5.21846C13.8963 5.01077 13.7313 4.8 13.5603 4.58769L13.0398 3.94615L12.4908 3.29231L12.2058 2.96L11.6178 2.28769L11.0058 1.60462L9.99331 0.5ZM9.99331 3.36462L10.6683 4.12462L11.1663 4.69846L11.6433 5.25846L12.0993 5.80615L12.5328 6.33846L12.9438 6.85846L13.3338 7.36615L13.7028 7.85846L14.0478 8.33846L14.3748 8.80615L14.6778 9.26C14.7753 9.40923 14.8698 9.55538 14.9598 9.7L15.2208 10.1277L15.3408 10.3369L15.5703 10.7462C15.6063 10.8123 15.6423 10.88 15.6753 10.9462L15.8718 11.3354C17.2923 14.2738 16.8243 16.1 14.5308 16.9738L14.2218 17.0815C13.7418 17.2385 13.1913 17.3569 12.5718 17.44L12.1503 17.4908L11.7063 17.5308L11.2413 17.5615L10.7583 17.5815L10.2528 17.5923H9.99331L9.47731 17.5877L9.22831 17.5815L8.74381 17.5615L8.27881 17.5308L7.83631 17.4908L7.41331 17.44C6.79381 17.3569 6.24332 17.2385 5.76332 17.0831L5.45432 16.9754C3.15932 16.0985 2.69282 14.2723 4.11332 11.3354L4.30832 10.9446L4.41482 10.7446L4.64282 10.3369L4.76582 10.1277L5.02532 9.7C5.11532 9.55538 5.20982 9.40769 5.30732 9.26L5.61182 8.80615L5.93581 8.33846L6.28382 7.85846L6.65132 7.36615L7.04132 6.85846L7.45381 6.33846L7.88731 5.80615L8.34181 5.25846L8.81882 4.69846L9.31831 4.12462L9.99331 3.36462Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_619_4710)">
          <path
            d="M9.90381 0.500481C9.9742 0.499866 10.0446 0.499927 10.115 0.500663L9.9998 11.5001L9.90381 0.500481Z"
            fill="#FF0000"
          />
          <path
            d="M10.096 0.500427C10.1664 0.501042 10.2368 0.502331 10.3071 0.504297L10 11.5L10.096 0.500427Z"
            fill="#FF0400"
          />
          <path
            d="M10.2879 0.503845C10.3583 0.505688 10.4287 0.508206 10.499 0.511399L10 11.5001L10.2879 0.503845Z"
            fill="#FF0900"
          />
          <path
            d="M10.4798 0.510559C10.5501 0.51363 10.6204 0.517375 10.6907 0.521796L10 11.5001L10.4798 0.510559Z"
            fill="#FF0D00"
          />
          <path
            d="M10.6715 0.520508C10.7418 0.524805 10.812 0.529777 10.8822 0.535423L10 11.5L10.6715 0.520508Z"
            fill="#FF1100"
          />
          <path
            d="M10.863 0.533936C10.9332 0.539459 11.0034 0.545655 11.0734 0.552525L10 11.5L10.863 0.533936Z"
            fill="#FF1500"
          />
          <path
            d="M11.0543 0.55072C11.1244 0.557467 11.1944 0.564887 11.2643 0.572978L10 11.5001L11.0543 0.55072Z"
            fill="#FF1A00"
          />
          <path
            d="M11.2452 0.570801C11.3152 0.57877 11.385 0.58741 11.4548 0.59672L10 11.5001L11.2452 0.570801Z"
            fill="#FF1E00"
          />
          <path
            d="M11.4358 0.594177C11.5056 0.603366 11.5753 0.613224 11.6449 0.623751L10 11.5001L11.4358 0.594177Z"
            fill="#FF2200"
          />
          <path
            d="M11.6259 0.620911C11.6955 0.631316 11.765 0.642389 11.8345 0.654129L10 11.5001L11.6259 0.620911Z"
            fill="#FF2600"
          />
          <path
            d="M11.8155 0.651245C11.885 0.662864 11.9543 0.675149 12.0235 0.688098L10 11.5004L11.8155 0.651245Z"
            fill="#FF2B00"
          />
          <path
            d="M12.0046 0.684204C12.0738 0.697033 12.1429 0.710526 12.2119 0.72468L10 11.5L12.0046 0.684204Z"
            fill="#FF2F00"
          />
          <path
            d="M12.193 0.721069C12.262 0.735104 12.3309 0.749801 12.3996 0.765157L10 11.5002L12.193 0.721069Z"
            fill="#FF3300"
          />
          <path
            d="M12.3808 0.760803C12.4496 0.77604 12.5181 0.791935 12.5866 0.808488L10 11.5001L12.3808 0.760803Z"
            fill="#FF3700"
          />
          <path
            d="M12.5679 0.804321C12.6363 0.820755 12.7046 0.837845 12.7728 0.85559L10 11.5004L12.5679 0.804321Z"
            fill="#FF3C00"
          />
          <path
            d="M12.7542 0.850464C12.8223 0.868089 12.8903 0.886369 12.9581 0.905299L10 11.5001L12.7542 0.850464Z"
            fill="#FF4000"
          />
          <path
            d="M12.9396 0.900146C13.0075 0.918959 13.0751 0.938422 13.1426 0.958533L10 11.5001L12.9396 0.900146Z"
            fill="#FF4400"
          />
          <path
            d="M13.1242 0.953369C13.1917 0.973363 13.259 0.994003 13.3261 1.01529L10 11.5004L13.1242 0.953369Z"
            fill="#FF4800"
          />
          <path
            d="M13.3078 1.00916C13.3749 1.03032 13.4418 1.05214 13.5086 1.07459L10 11.5L13.3078 1.00916Z"
            fill="#FF4D00"
          />
          <path
            d="M13.4903 1.06885C13.5571 1.09118 13.6236 1.11416 13.69 1.13778L10 11.5004L13.4903 1.06885Z"
            fill="#FF5100"
          />
          <path
            d="M13.6719 1.13104C13.7382 1.15454 13.8044 1.17868 13.8703 1.20344L10 11.5001L13.6719 1.13104Z"
            fill="#FF5500"
          />
          <path
            d="M13.8523 1.19672C13.9182 1.22137 13.9839 1.24665 14.0494 1.27257L10 11.5001L13.8523 1.19672Z"
            fill="#FF5900"
          />
          <path
            d="M14.0315 1.26544C14.097 1.29124 14.1623 1.31767 14.2272 1.34472L10 11.5L14.0315 1.26544Z"
            fill="#FF5E00"
          />
          <path
            d="M14.2095 1.3374C14.2746 1.36434 14.3393 1.3919 14.4038 1.42009L10 11.5001L14.2095 1.3374Z"
            fill="#FF6200"
          />
          <path
            d="M14.3862 1.4126C14.4508 1.44067 14.5151 1.46936 14.5791 1.49866L10 11.5003L14.3862 1.4126Z"
            fill="#FF6600"
          />
          <path
            d="M14.5616 1.49054C14.6257 1.51973 14.6895 1.54954 14.7529 1.57996L10 11.5001L14.5616 1.49054Z"
            fill="#FF6A00"
          />
          <path
            d="M14.7356 1.57159C14.7992 1.6019 14.8624 1.63282 14.9253 1.66434L10 11.5L14.7356 1.57159Z"
            fill="#FF6F00"
          />
          <path
            d="M14.9082 1.65582C14.9712 1.68723 15.0339 1.71925 15.0963 1.75186L10 11.5001L14.9082 1.65582Z"
            fill="#FF7300"
          />
          <path
            d="M15.0792 1.74298C15.1417 1.77549 15.2038 1.80859 15.2656 1.84229L10 11.5001L15.0792 1.74298Z"
            fill="#FF7700"
          />
          <path
            d="M15.2487 1.83307C15.3106 1.86666 15.3721 1.90084 15.4334 1.93561L10 11.5001L15.2487 1.83307Z"
            fill="#FF7B00"
          />
          <path
            d="M15.4167 1.92615C15.4779 1.96081 15.5389 1.99606 15.5995 2.0319L10 11.5001L15.4167 1.92615Z"
            fill="#FF8000"
          />
          <path
            d="M15.5829 2.02222C15.6436 2.05795 15.7039 2.09426 15.7638 2.13114L10 11.5001L15.5829 2.02222Z"
            fill="#FF8400"
          />
          <path
            d="M15.7475 2.12097C15.8075 2.15775 15.8672 2.19511 15.9265 2.23304L10 11.5L15.7475 2.12097Z"
            fill="#FF8800"
          />
          <path
            d="M15.9103 2.22278C15.9697 2.2606 16.0287 2.29899 16.0873 2.33795L10 11.5001L15.9103 2.22278Z"
            fill="#FF8C00"
          />
          <path
            d="M16.0713 2.32733C16.13 2.36619 16.1883 2.4056 16.2463 2.44558L10 11.5001L16.0713 2.32733Z"
            fill="#FF9100"
          />
          <path
            d="M16.2305 2.43469C16.2885 2.47456 16.3461 2.51499 16.4034 2.55597L10 11.5001L16.2305 2.43469Z"
            fill="#FF9500"
          />
          <path
            d="M16.3877 2.5448C16.445 2.58568 16.502 2.62711 16.5585 2.66908L10 11.5001L16.3877 2.5448Z"
            fill="#FF9900"
          />
          <path
            d="M16.543 2.65765C16.5996 2.69953 16.6558 2.74194 16.7116 2.78489L10 11.5001L16.543 2.65765Z"
            fill="#FF9D00"
          />
          <path
            d="M16.6964 2.77319C16.7522 2.81605 16.8077 2.85944 16.8627 2.90336L10 11.5001L16.6964 2.77319Z"
            fill="#FFA200"
          />
          <path
            d="M16.8477 2.89136C16.9028 2.93518 16.9574 2.97953 17.0117 3.0244L10 11.5001L16.8477 2.89136Z"
            fill="#FFA600"
          />
          <path
            d="M16.9969 3.01221C17.0512 3.05698 17.1051 3.10228 17.1585 3.14809L10 11.5001L16.9969 3.01221Z"
            fill="#FFAA00"
          />
          <path
            d="M17.1439 3.13562C17.1975 3.18134 17.2505 3.22757 17.3032 3.27431L10 11.5001L17.1439 3.13562Z"
            fill="#FFAE00"
          />
          <path
            d="M17.2888 3.2616C17.3415 3.30824 17.3938 3.35539 17.4456 3.40304L10 11.5001L17.2888 3.2616Z"
            fill="#FFB300"
          />
          <path
            d="M17.4315 3.38995C17.4834 3.43751 17.5348 3.48557 17.5858 3.53411L10 11.5L17.4315 3.38995Z"
            fill="#FFB700"
          />
          <path
            d="M17.5719 3.521C17.623 3.56945 17.6736 3.6184 17.7237 3.66783L10 11.5001L17.5719 3.521Z"
            fill="#FFBB00"
          />
          <path
            d="M17.5719 3.521C17.623 3.56945 17.6736 3.6184 17.7237 3.66783L10 11.5001L17.5719 3.521Z"
            fill="#FFBB00"
          />
          <path
            d="M17.71 3.6543C17.7602 3.70364 17.8099 3.75346 17.8592 3.80375L10 11.5001L17.71 3.6543Z"
            fill="#FFBF00"
          />
          <path
            d="M17.8458 3.79004C17.8951 3.84025 17.9439 3.89093 17.9923 3.94208L10 11.5L17.8458 3.79004Z"
            fill="#FFC400"
          />
          <path
            d="M17.9791 3.92816C18.0276 3.97922 18.0755 4.03075 18.123 4.08274L10 11.5001L17.9791 3.92816Z"
            fill="#FFC800"
          />
          <path
            d="M18.11 4.0686C18.1576 4.1205 18.2047 4.17286 18.2512 4.22566L10 11.5001L18.11 4.0686Z"
            fill="#FFCC00"
          />
          <path
            d="M18.2385 4.21124C18.2852 4.26397 18.3313 4.31714 18.3769 4.37074L10 11.5001L18.2385 4.21124Z"
            fill="#FFD000"
          />
          <path
            d="M18.3645 4.35614C18.4102 4.40967 18.4554 4.46364 18.5001 4.51803L10 11.5001L18.3645 4.35614Z"
            fill="#FFD500"
          />
          <path
            d="M18.4879 4.50317C18.5326 4.55749 18.5769 4.61224 18.6206 4.66741L10 11.5L18.4879 4.50317Z"
            fill="#FFD900"
          />
          <path
            d="M18.6087 4.65271C18.6525 4.7078 18.6958 4.76331 18.7386 4.81924L10 11.5004L18.6087 4.65271Z"
            fill="#FFDD00"
          />
          <path
            d="M18.7269 4.80365C18.7697 4.8595 18.8121 4.91576 18.8538 4.97242L10 11.5L18.7269 4.80365Z"
            fill="#FFE100"
          />
          <path
            d="M18.8424 4.95697C18.8843 5.01356 18.9256 5.07055 18.9664 5.12793L10 11.5L18.8424 4.95697Z"
            fill="#FFE600"
          />
          <path
            d="M18.9553 5.11237C18.9961 5.16968 19.0365 5.22738 19.0762 5.28546L10 11.5001L18.9553 5.11237Z"
            fill="#FFEA00"
          />
          <path
            d="M19.0654 5.26959C19.1053 5.32761 19.1446 5.386 19.1833 5.44477L10 11.5001L19.0654 5.26959Z"
            fill="#FFEE00"
          />
          <path
            d="M19.1727 5.42883C19.2116 5.48753 19.2499 5.54661 19.2876 5.60604L10 11.5001L19.1727 5.42883Z"
            fill="#FFF200"
          />
          <path
            d="M19.2773 5.58997C19.3151 5.64934 19.3524 5.70907 19.3891 5.76916L10 11.5003L19.2773 5.58997Z"
            fill="#FFF700"
          />
          <path
            d="M19.379 5.75262C19.4158 5.81265 19.452 5.87302 19.4876 5.93374L10 11.5001L19.379 5.75262Z"
            fill="#FFFB00"
          />
          <path
            d="M19.4779 5.91711C19.5136 5.97777 19.5488 6.03877 19.5833 6.10009L10 11.5L19.4779 5.91711Z"
            fill="#FFFF00"
          />
          <path
            d="M19.5739 6.08337C19.6086 6.14464 19.6426 6.20624 19.6761 6.26817L10 11.5L19.5739 6.08337Z"
            fill="#FBFF00"
          />
          <path
            d="M19.667 6.25128C19.7006 6.31315 19.7336 6.37533 19.766 6.43783L10 11.5L19.667 6.25128Z"
            fill="#F7FF00"
          />
          <path
            d="M19.7571 6.42114C19.7896 6.48358 19.8215 6.54634 19.8528 6.60939L10 11.5004L19.7571 6.42114Z"
            fill="#F2FF00"
          />
          <path
            d="M19.8443 6.59192C19.8757 6.65492 19.9065 6.71822 19.9367 6.78181L10 11.5001L19.8443 6.59192Z"
            fill="#EEFF00"
          />
          <path
            d="M19.9284 6.7644C19.9587 6.82794 19.9884 6.89177 20.0175 6.95588L10 11.5L19.9284 6.7644Z"
            fill="#EAFF00"
          />
          <path
            d="M20.0096 6.93848C20.0388 7.00253 20.0673 7.06687 20.0953 7.13148L10 11.5001L20.0096 6.93848Z"
            fill="#E6FF00"
          />
          <path
            d="M20.0877 7.11401C20.1157 7.17857 20.1432 7.2434 20.17 7.30848L10 11.5003L20.0877 7.11401Z"
            fill="#E1FF00"
          />
          <path
            d="M20.1627 7.29053C20.1896 7.35556 20.2159 7.42086 20.2416 7.4864L10 11.5L20.1627 7.29053Z"
            fill="#DDFF00"
          />
          <path
            d="M20.2346 7.46857C20.2604 7.53406 20.2856 7.59981 20.3101 7.66579L10 11.5001L20.2346 7.46857Z"
            fill="#D9FF00"
          />
          <path
            d="M20.3034 7.64777C20.328 7.7137 20.3521 7.77988 20.3754 7.84627L10 11.5L20.3034 7.64777Z"
            fill="#D5FF00"
          />
          <path
            d="M20.3691 7.82837C20.3926 7.89473 20.4154 7.96131 20.4376 8.02811L10 11.5002L20.3691 7.82837Z"
            fill="#D0FF00"
          />
          <path
            d="M20.4316 8.00977C20.4539 8.07652 20.4756 8.14349 20.4966 8.21067L10 11.5001L20.4316 8.00977Z"
            fill="#CCFF00"
          />
          <path
            d="M20.4909 8.19232C20.5121 8.25946 20.5326 8.3268 20.5525 8.39433L10 11.5001L20.4909 8.19232Z"
            fill="#C8FF00"
          />
          <path
            d="M20.547 8.37622C20.567 8.44372 20.5864 8.5114 20.605 8.57927L10 11.5004L20.547 8.37622Z"
            fill="#C4FF00"
          />
          <path
            d="M20.5999 8.56049C20.6187 8.62832 20.6369 8.69634 20.6544 8.76452L10 11.5001L20.5999 8.56049Z"
            fill="#BFFF00"
          />
          <path
            d="M20.6496 8.74591C20.6672 8.81406 20.6842 8.88238 20.7005 8.95086L10 11.5001L20.6496 8.74591Z"
            fill="#BBFF00"
          />
          <path
            d="M20.6961 8.93219C20.7125 9.00064 20.7283 9.06925 20.7434 9.138L10 11.5001L20.6961 8.93219Z"
            fill="#B7FF00"
          />
          <path
            d="M20.7393 9.1192C20.7545 9.18793 20.7691 9.2568 20.783 9.32581L10 11.5L20.7393 9.1192Z"
            fill="#B3FF00"
          />
          <path
            d="M20.7792 9.30701C20.7932 9.37599 20.8066 9.44511 20.8193 9.51434L10 11.5001L20.7792 9.30701Z"
            fill="#AEFF00"
          />
          <path
            d="M20.8158 9.49542C20.8286 9.56464 20.8408 9.63398 20.8523 9.70343L10 11.5L20.8158 9.49542Z"
            fill="#AAFF00"
          />
          <path
            d="M20.8491 9.68451C20.8608 9.75394 20.8717 9.82348 20.882 9.89312L10 11.5L20.8491 9.68451Z"
            fill="#A6FF00"
          />
          <path
            d="M20.8792 9.87415C20.8896 9.94377 20.8993 10.0135 20.9084 10.0833L10 11.5001L20.8792 9.87415Z"
            fill="#A2FF00"
          />
          <path
            d="M20.9059 10.0643C20.9151 10.1341 20.9236 10.2039 20.9314 10.2739L10 11.5001L20.9059 10.0643Z"
            fill="#9EFF00"
          />
          <path
            d="M20.9293 10.2549C20.9373 10.3248 20.9446 10.3948 20.9512 10.4649L10 11.5001L20.9293 10.2549Z"
            fill="#99FF00"
          />
          <path
            d="M20.9494 10.4457C20.9561 10.5158 20.9622 10.5859 20.9676 10.6561L10 11.5L20.9494 10.4457Z"
            fill="#95FF00"
          />
          <path
            d="M20.9661 10.637C20.9716 10.7071 20.9765 10.7774 20.9806 10.8476L10 11.5L20.9661 10.637Z"
            fill="#91FF00"
          />
          <path
            d="M20.9795 10.8286C20.9838 10.8988 20.9874 10.9691 20.9903 11.0395L10 11.5001L20.9795 10.8286Z"
            fill="#8CFF00"
          />
          <path
            d="M20.9895 11.0203C20.9926 11.0906 20.995 11.1609 20.9967 11.2313L10 11.5001L20.9895 11.0203Z"
            fill="#88FF00"
          />
          <path
            d="M20.9962 11.2122C20.9981 11.2825 20.9992 11.3529 20.9997 11.4233L10 11.5001L20.9962 11.2122Z"
            fill="#84FF00"
          />
          <path
            d="M20.9996 11.4042C21.0002 11.4746 21.0001 11.545 20.9994 11.6154L10 11.5002L20.9996 11.4042Z"
            fill="#80FF00"
          />
          <path
            d="M20.9996 11.5961C20.999 11.6664 20.9977 11.7368 20.9957 11.8072L10 11.5001L20.9996 11.5961Z"
            fill="#7BFF00"
          />
          <path
            d="M20.9962 11.788C20.9944 11.8584 20.9919 11.9287 20.9887 11.9991L10 11.5001L20.9962 11.788Z"
            fill="#77FF00"
          />
          <path
            d="M20.9895 11.9799C20.9865 12.0502 20.9827 12.1205 20.9783 12.1908L10 11.5001L20.9895 11.9799Z"
            fill="#73FF00"
          />
          <path
            d="M20.9795 12.1716C20.9752 12.2419 20.9702 12.3121 20.9646 12.3822L10 11.5001L20.9795 12.1716Z"
            fill="#6FFF00"
          />
          <path
            d="M20.9661 12.3631C20.9606 12.4333 20.9544 12.5034 20.9475 12.5735L10 11.5001L20.9661 12.3631Z"
            fill="#6AFF00"
          />
          <path
            d="M20.9494 12.5544C20.9426 12.6244 20.9352 12.6944 20.9271 12.7644L10 11.5001L20.9494 12.5544Z"
            fill="#66FF00"
          />
          <path
            d="M20.9293 12.7453C20.9213 12.8152 20.9127 12.8851 20.9034 12.9549L10 11.5001L20.9293 12.7453Z"
            fill="#62FF00"
          />
          <path
            d="M20.9059 12.9359C20.8967 13.0056 20.8868 13.0753 20.8763 13.145L10 11.5001L20.9059 12.9359Z"
            fill="#5EFF00"
          />
          <path
            d="M20.8792 13.126C20.8688 13.1956 20.8577 13.2651 20.846 13.3345L10 11.5001L20.8792 13.126Z"
            fill="#59FF00"
          />
          <path
            d="M20.8491 13.3156C20.8375 13.385 20.8252 13.4543 20.8123 13.5235L10 11.5001L20.8491 13.3156Z"
            fill="#55FF00"
          />
          <path
            d="M20.8158 13.5047C20.803 13.5739 20.7895 13.643 20.7753 13.7119L10 11.5001L20.8158 13.5047Z"
            fill="#51FF00"
          />
          <path
            d="M20.7792 13.6931C20.7651 13.7621 20.7504 13.8309 20.7351 13.8996L10 11.5001L20.7792 13.6931Z"
            fill="#4DFF00"
          />
          <path
            d="M20.7393 13.8809C20.724 13.9496 20.7081 14.0182 20.6916 14.0866L10 11.5001L20.7393 13.8809Z"
            fill="#48FF00"
          />
          <path
            d="M20.6961 14.068C20.6796 14.1364 20.6625 14.2047 20.6448 14.2728L10 11.5001L20.6961 14.068Z"
            fill="#44FF00"
          />
          <path
            d="M20.6496 14.2542C20.632 14.3224 20.6137 14.3904 20.5948 14.4582L10 11.5001L20.6496 14.2542Z"
            fill="#40FF00"
          />
          <path
            d="M20.5999 14.4397C20.5811 14.5075 20.5617 14.5752 20.5415 14.6426L10 11.5001L20.5999 14.4397Z"
            fill="#3CFF00"
          />
          <path
            d="M20.547 14.6242C20.527 14.6917 20.5064 14.759 20.4851 14.8261L10 11.5001L20.547 14.6242Z"
            fill="#37FF00"
          />
          <path
            d="M20.4909 14.8078C20.4697 14.875 20.4479 14.9419 20.4254 15.0086L10 11.5001L20.4909 14.8078Z"
            fill="#33FF00"
          />
          <path
            d="M20.4316 14.9904C20.4092 15.0572 20.3862 15.1237 20.3626 15.19L10 11.5001L20.4316 14.9904Z"
            fill="#2FFF00"
          />
          <path
            d="M20.3691 15.1719C20.3456 15.2383 20.3214 15.3044 20.2967 15.3703L10 11.5001L20.3691 15.1719Z"
            fill="#2BFF00"
          />
          <path
            d="M20.3034 15.3523C20.2787 15.4183 20.2535 15.484 20.2275 15.5494L10 11.5001L20.3034 15.3523Z"
            fill="#26FF00"
          />
          <path
            d="M20.2346 15.5316C20.2088 15.5971 20.1824 15.6623 20.1553 15.7273L10 11.5001L20.2346 15.5316Z"
            fill="#22FF00"
          />
          <path
            d="M20.1627 15.7096C20.1357 15.7746 20.1082 15.8394 20.08 15.9039L10 11.5001L20.1627 15.7096Z"
            fill="#1EFF00"
          />
          <path
            d="M20.0877 15.8863C20.0596 15.9509 20.0309 16.0151 20.0016 16.0792L10 11.5001L20.0877 15.8863Z"
            fill="#1AFF00"
          />
          <path
            d="M20.0096 16.0617C19.9804 16.1257 19.9506 16.1895 19.9202 16.253L10 11.5001L20.0096 16.0617Z"
            fill="#15FF00"
          />
          <path
            d="M19.9284 16.2357C19.8981 16.2992 19.8672 16.3625 19.8357 16.4254L10 11.5001L19.9284 16.2357Z"
            fill="#11FF00"
          />
          <path
            d="M19.8443 16.4082C19.8129 16.4712 19.7808 16.5339 19.7482 16.5963L10 11.5001L19.8443 16.4082Z"
            fill="#0DFF00"
          />
          <path
            d="M19.7571 16.5793C19.7246 16.6417 19.6915 16.7039 19.6578 16.7657L10 11.5001L19.7571 16.5793Z"
            fill="#09FF00"
          />
          <path
            d="M19.667 16.7488C19.6334 16.8107 19.5992 16.8722 19.5644 16.9334L10 11.5001L19.667 16.7488Z"
            fill="#04FF00"
          />
          <path
            d="M19.5739 16.9167C19.5392 16.978 19.504 17.0389 19.4682 17.0995L10 11.5001L19.5739 16.9167Z"
            fill="#00FF00"
          />
          <path
            d="M19.4779 17.083C19.4422 17.1436 19.4059 17.204 19.369 17.2639L10 11.5001L19.4779 17.083Z"
            fill="#00FF04"
          />
          <path
            d="M19.379 17.2475C19.3423 17.3076 19.3049 17.3672 19.267 17.4265L10 11.5001L19.379 17.2475Z"
            fill="#00FF09"
          />
          <path
            d="M19.2773 17.4104C19.2395 17.4697 19.2011 17.5287 19.1621 17.5874L10 11.5001L19.2773 17.4104Z"
            fill="#00FF0D"
          />
          <path
            d="M19.1727 17.5714C19.1339 17.6301 19.0945 17.6884 19.0545 17.7463L10 11.5001L19.1727 17.5714Z"
            fill="#00FF11"
          />
          <path
            d="M19.0654 17.7305C19.0255 17.7885 18.9851 17.8462 18.9441 17.9034L10 11.5001L19.0654 17.7305Z"
            fill="#00FF15"
          />
          <path
            d="M18.9553 17.8878C18.9144 17.9451 18.873 18.002 18.831 18.0585L10 11.5001L18.9553 17.8878Z"
            fill="#00FF1A"
          />
          <path
            d="M18.8424 18.0431C18.8005 18.0997 18.7581 18.1559 18.7152 18.2117L10 11.5001L18.8424 18.0431Z"
            fill="#00FF1E"
          />
          <path
            d="M18.7269 18.1964C18.684 18.2523 18.6406 18.3077 18.5967 18.3627L10 11.5001L18.7269 18.1964Z"
            fill="#00FF22"
          />
          <path
            d="M18.6087 18.3477C18.5649 18.4028 18.5205 18.4575 18.4756 18.5117L10 11.5001L18.6087 18.3477Z"
            fill="#00FF26"
          />
          <path
            d="M18.4879 18.4969C18.4431 18.5512 18.3978 18.6051 18.352 18.6586L10 11.5001L18.4879 18.4969Z"
            fill="#00FF2B"
          />
          <path
            d="M18.3645 18.644C18.3187 18.6975 18.2725 18.7506 18.2258 18.8033L10 11.5001L18.3645 18.644Z"
            fill="#00FF2F"
          />
          <path
            d="M18.2385 18.7889C18.1919 18.8416 18.1447 18.8939 18.0971 18.9457L10 11.5001L18.2385 18.7889Z"
            fill="#00FF33"
          />
          <path
            d="M18.11 18.9316C18.0625 18.9835 18.0144 19.0349 17.9659 19.0859L10 11.5001L18.11 18.9316Z"
            fill="#00FF37"
          />
          <path
            d="M17.9791 19.072C17.9307 19.123 17.8817 19.1736 17.8323 19.2237L10 11.5001L17.9791 19.072Z"
            fill="#00FF3C"
          />
          <path
            d="M17.8458 19.2101C17.7964 19.2603 17.7466 19.31 17.6963 19.3593L10 11.5001L17.8458 19.2101Z"
            fill="#00FF40"
          />
          <path
            d="M17.71 19.3458C17.6598 19.3952 17.6091 19.444 17.558 19.4924L10 11.5001L17.71 19.3458Z"
            fill="#00FF44"
          />
          <path
            d="M17.5719 19.4792C17.5208 19.5276 17.4693 19.5756 17.4173 19.6231L10 11.5001L17.5719 19.4792Z"
            fill="#00FF48"
          />
          <path
            d="M17.4315 19.6101C17.3796 19.6577 17.3272 19.7047 17.2744 19.7513L10 11.5001L17.4315 19.6101Z"
            fill="#00FF4D"
          />
          <path
            d="M17.2888 19.7386C17.2361 19.7852 17.1829 19.8314 17.1293 19.877L10 11.5001L17.2888 19.7386Z"
            fill="#00FF51"
          />
          <path
            d="M17.1439 19.8645C17.0904 19.9102 17.0364 19.9555 16.982 20.0001L10 11.5001L17.1439 19.8645Z"
            fill="#00FF55"
          />
          <path
            d="M16.9969 19.9879C16.9425 20.0327 16.8878 20.077 16.8326 20.1207L10 11.5001L16.9969 19.9879Z"
            fill="#00FF59"
          />
          <path
            d="M16.8477 20.1088C16.7926 20.1526 16.7371 20.1959 16.6811 20.2386L10 11.5001L16.8477 20.1088Z"
            fill="#00FF5E"
          />
          <path
            d="M16.6964 20.227C16.6405 20.2698 16.5843 20.3121 16.5276 20.3539L10 11.5001L16.6964 20.227Z"
            fill="#00FF62"
          />
          <path
            d="M16.543 20.3425C16.4865 20.3844 16.4295 20.4257 16.3721 20.4665L10 11.5001L16.543 20.3425Z"
            fill="#00FF66"
          />
          <path
            d="M16.3877 20.4553C16.3304 20.4962 16.2727 20.5365 16.2146 20.5763L10 11.5001L16.3877 20.4553Z"
            fill="#00FF6A"
          />
          <path
            d="M16.2305 20.5655C16.1725 20.6053 16.1141 20.6446 16.0553 20.6834L10 11.5001L16.2305 20.5655Z"
            fill="#00FF6F"
          />
          <path
            d="M16.0713 20.6728C16.0126 20.7117 15.9535 20.75 15.8941 20.7877L10 11.5001L16.0713 20.6728Z"
            fill="#00FF73"
          />
          <path
            d="M15.9103 20.7774C15.8509 20.8152 15.7912 20.8524 15.7311 20.8891L10 11.5001L15.9103 20.7774Z"
            fill="#00FF77"
          />
          <path
            d="M15.7475 20.8791C15.6875 20.9159 15.6271 20.9521 15.5664 20.9877L10 11.5001L15.7475 20.8791Z"
            fill="#00FF7B"
          />
          <path
            d="M15.5829 20.978C15.5223 21.0137 15.4613 21.0489 15.3999 21.0834L10 11.5001L15.5829 20.978Z"
            fill="#00FF80"
          />
          <path
            d="M15.4167 21.074C15.3554 21.1086 15.2938 21.1427 15.2319 21.1762L10 11.5001L15.4167 21.074Z"
            fill="#00FF84"
          />
          <path
            d="M15.2487 21.1671C15.1869 21.2006 15.1247 21.2336 15.0622 21.266L10 11.5001L15.2487 21.1671Z"
            fill="#00FF88"
          />
          <path
            d="M15.0792 21.2572C15.0168 21.2897 14.954 21.3216 14.891 21.3529L10 11.5001L15.0792 21.2572Z"
            fill="#00FF8C"
          />
          <path
            d="M14.9082 21.3443C14.8452 21.3758 14.7819 21.4066 14.7183 21.4368L10 11.5001L14.9082 21.3443Z"
            fill="#00FF91"
          />
          <path
            d="M14.7356 21.4285C14.6721 21.4588 14.6083 21.4885 14.5441 21.5176L10 11.5001L14.7356 21.4285Z"
            fill="#00FF95"
          />
          <path
            d="M14.5616 21.5096C14.4976 21.5388 14.4332 21.5674 14.3686 21.5954L10 11.5001L14.5616 21.5096Z"
            fill="#00FF99"
          />
          <path
            d="M14.3862 21.5877C14.3217 21.6158 14.2569 21.6432 14.1918 21.6701L10 11.5001L14.3862 21.5877Z"
            fill="#00FF9D"
          />
          <path
            d="M14.2095 21.6627C14.1445 21.6897 14.0792 21.716 14.0136 21.7417L10 11.5001L14.2095 21.6627Z"
            fill="#00FFA2"
          />
          <path
            d="M14.0315 21.7347C13.966 21.7605 13.9003 21.7856 13.8343 21.8102L10 11.5001L14.0315 21.7347Z"
            fill="#00FFA6"
          />
          <path
            d="M13.8523 21.8035C13.7863 21.8281 13.7202 21.8521 13.6538 21.8755L10 11.5001L13.8523 21.8035Z"
            fill="#00FFAA"
          />
          <path
            d="M13.6719 21.8691C13.6055 21.8926 13.5389 21.9155 13.4721 21.9377L10 11.5001L13.6719 21.8691Z"
            fill="#00FFAE"
          />
          <path
            d="M13.4903 21.9316C13.4236 21.954 13.3566 21.9757 13.2894 21.9967L10 11.5001L13.4903 21.9316Z"
            fill="#00FFB3"
          />
          <path
            d="M13.3078 21.991C13.2406 22.0121 13.1733 22.0326 13.1058 22.0525L10 11.5001L13.3078 21.991Z"
            fill="#00FFB7"
          />
          <path
            d="M13.1242 22.0471C13.0567 22.0671 12.989 22.0864 12.9211 22.1051L10 11.5001L13.1242 22.0471Z"
            fill="#00FFBB"
          />
          <path
            d="M12.9396 22.1C12.8718 22.1188 12.8038 22.137 12.7356 22.1545L10 11.5001L12.9396 22.1Z"
            fill="#00FFBF"
          />
          <path
            d="M12.7542 22.1497C12.686 22.1673 12.6177 22.1843 12.5492 22.2006L10 11.5001L12.7542 22.1497Z"
            fill="#00FFC4"
          />
          <path
            d="M12.5679 22.1961C12.4994 22.2126 12.4308 22.2283 12.3621 22.2435L10 11.5001L12.5679 22.1961Z"
            fill="#00FFC8"
          />
          <path
            d="M12.3808 22.2393C12.3121 22.2546 12.2432 22.2691 12.1742 22.2831L10 11.5001L12.3808 22.2393Z"
            fill="#00FFCC"
          />
          <path
            d="M12.193 22.2792C12.1241 22.2933 12.0549 22.3066 11.9857 22.3194L10 11.5001L12.193 22.2792Z"
            fill="#00FFD0"
          />
          <path
            d="M12.0046 22.3159C11.9354 22.3287 11.866 22.3409 11.7966 22.3524L10 11.5001L12.0046 22.3159Z"
            fill="#00FFD5"
          />
          <path
            d="M11.8155 22.3492C11.7461 22.3608 11.6766 22.3718 11.6069 22.3821L10 11.5001L11.8155 22.3492Z"
            fill="#00FFD9"
          />
          <path
            d="M11.6259 22.3792C11.5563 22.3896 11.4866 22.3994 11.4168 22.4084L10 11.5001L11.6259 22.3792Z"
            fill="#00FFDD"
          />
          <path
            d="M11.4358 22.406C11.366 22.4152 11.2961 22.4237 11.2262 22.4315L10 11.5001L11.4358 22.406Z"
            fill="#00FFE1"
          />
          <path
            d="M11.2452 22.4294C11.1753 22.4373 11.1053 22.4446 11.0352 22.4512L10 11.5001L11.2452 22.4294Z"
            fill="#00FFE6"
          />
          <path
            d="M11.0543 22.4494C10.9842 22.4562 10.9141 22.4622 10.8439 22.4676L10 11.5001L11.0543 22.4494Z"
            fill="#00FFEA"
          />
          <path
            d="M10.863 22.4662C10.7929 22.4717 10.7226 22.4765 10.6524 22.4807L10 11.5001L10.863 22.4662Z"
            fill="#00FFEE"
          />
          <path
            d="M10.6715 22.4795C10.6013 22.4838 10.531 22.4875 10.4606 22.4904L10 11.5001L10.6715 22.4795Z"
            fill="#00FFF2"
          />
          <path
            d="M10.4798 22.4896C10.4095 22.4927 10.3391 22.4951 10.2688 22.4968L10 11.5001L10.4798 22.4896Z"
            fill="#00FFF7"
          />
          <path
            d="M10.2879 22.4963C10.2176 22.4981 10.1472 22.4993 10.0768 22.4998L10 11.5001L10.2879 22.4963Z"
            fill="#00FFFB"
          />
          <path
            d="M10.0959 22.4996C10.0256 22.5003 9.95516 22.5002 9.88477 22.4995L9.99996 11.5001L10.0959 22.4996Z"
            fill="#00FFFF"
          />
          <path
            d="M9.90396 22.4996C9.83356 22.499 9.76318 22.4977 9.69281 22.4958L9.99995 11.5001L9.90396 22.4996Z"
            fill="#00FBFF"
          />
          <path
            d="M9.71196 22.4963C9.64159 22.4945 9.57124 22.4919 9.50092 22.4887L9.99991 11.5001L9.71196 22.4963Z"
            fill="#00F7FF"
          />
          <path
            d="M9.52021 22.4896C9.44988 22.4865 9.37958 22.4828 9.30933 22.4784L10 11.5001L9.52021 22.4896Z"
            fill="#00F2FF"
          />
          <path
            d="M9.32845 22.4795C9.25819 22.4753 9.18797 22.4703 9.1178 22.4646L9.99999 11.5001L9.32845 22.4795Z"
            fill="#00EEFF"
          />
          <path
            d="M9.13663 22.4662C9.06645 22.4606 8.99633 22.4544 8.92627 22.4476L9.99968 11.5001L9.13663 22.4662Z"
            fill="#00EAFF"
          />
          <path
            d="M8.9456 22.4494C8.87553 22.4427 8.80552 22.4353 8.7356 22.4272L9.9999 11.5001L8.9456 22.4494Z"
            fill="#00E6FF"
          />
          <path
            d="M8.75451 22.4294C8.68456 22.4214 8.6147 22.4127 8.54492 22.4034L9.99974 11.5001L8.75451 22.4294Z"
            fill="#00E1FF"
          />
          <path
            d="M8.5642 22.406C8.49441 22.3968 8.42471 22.3869 8.3551 22.3764L9.99999 11.5001L8.5642 22.406Z"
            fill="#00DDFF"
          />
          <path
            d="M8.37408 22.3792C8.30446 22.3688 8.23494 22.3578 8.16553 22.346L9.99998 11.5001L8.37408 22.3792Z"
            fill="#00D9FF"
          />
          <path
            d="M8.18444 22.3492C8.11501 22.3376 8.0457 22.3253 7.9765 22.3124L9.99997 11.5001L8.18444 22.3492Z"
            fill="#00D5FF"
          />
          <path
            d="M7.99541 22.3159C7.9262 22.303 7.8571 22.2896 7.78815 22.2754L10 11.5001L7.99541 22.3159Z"
            fill="#00D0FF"
          />
          <path
            d="M7.80693 22.2792C7.73795 22.2652 7.6691 22.2505 7.6004 22.2352L9.99998 11.5001L7.80693 22.2792Z"
            fill="#00CCFF"
          />
          <path
            d="M7.61918 22.2393C7.55045 22.2241 7.48187 22.2082 7.41345 22.1916L10 11.5001L7.61918 22.2393Z"
            fill="#00C8FF"
          />
          <path
            d="M7.4321 22.1961C7.36365 22.1797 7.29536 22.1626 7.22723 22.1449L10 11.5001L7.4321 22.1961Z"
            fill="#00C4FF"
          />
          <path
            d="M7.24581 22.1497C7.17765 22.1321 7.10967 22.1138 7.04187 22.0949L9.99999 11.5001L7.24581 22.1497Z"
            fill="#00BFFF"
          />
          <path
            d="M7.06037 22.1C6.99254 22.0812 6.92488 22.0617 6.85742 22.0416L9.99999 11.5001L7.06037 22.1Z"
            fill="#00BBFF"
          />
          <path
            d="M6.87579 22.0471C6.80829 22.0271 6.74099 22.0064 6.67389 21.9852L9.99996 11.5001L6.87579 22.0471Z"
            fill="#00B7FF"
          />
          <path
            d="M6.69218 21.991C6.62505 21.9698 6.55811 21.948 6.49139 21.9255L9.99995 11.5001L6.69218 21.991Z"
            fill="#00B3FF"
          />
          <path
            d="M6.50961 21.9316C6.44286 21.9093 6.37631 21.8863 6.31 21.8627L9.99996 11.5001L6.50961 21.9316Z"
            fill="#00AEFF"
          />
          <path
            d="M6.32814 21.8691C6.26179 21.8456 6.19566 21.8215 6.12976 21.7967L10 11.5001L6.32814 21.8691Z"
            fill="#00AAFF"
          />
          <path
            d="M6.14765 21.8035C6.08171 21.7788 6.01601 21.7535 5.95056 21.7276L9.99993 11.5001L6.14765 21.8035Z"
            fill="#00A6FF"
          />
          <path
            d="M5.9685 21.7347C5.903 21.7089 5.83776 21.6824 5.77277 21.6554L10 11.5001L5.9685 21.7347Z"
            fill="#00A2FF"
          />
          <path
            d="M5.79039 21.6627C5.72535 21.6358 5.66058 21.6082 5.59607 21.5801L9.99991 11.5001L5.79039 21.6627Z"
            fill="#009DFF"
          />
          <path
            d="M5.61375 21.5877C5.54919 21.5597 5.4849 21.531 5.4209 21.5017L9.99999 11.5001L5.61375 21.5877Z"
            fill="#0099FF"
          />
          <path
            d="M5.43833 21.5096C5.37427 21.4804 5.31049 21.4506 5.24701 21.4202L9.99995 11.5001L5.43833 21.5096Z"
            fill="#0095FF"
          />
          <path
            d="M5.26437 21.4285C5.20084 21.3982 5.13759 21.3673 5.07465 21.3358L9.99999 11.5001L5.26437 21.4285Z"
            fill="#0091FF"
          />
          <path
            d="M5.09183 21.3443C5.02883 21.3129 4.96613 21.2809 4.90375 21.2483L10 11.5001L5.09183 21.3443Z"
            fill="#008CFF"
          />
          <path
            d="M4.92051 21.2572C4.85806 21.2247 4.79594 21.1916 4.73413 21.1579L9.99974 11.5001L4.92051 21.2572Z"
            fill="#0088FF"
          />
          <path
            d="M4.75126 21.1671C4.6894 21.1335 4.62786 21.0993 4.56665 21.0645L10 11.5001L4.75126 21.1671Z"
            fill="#0084FF"
          />
          <path
            d="M4.58331 21.074C4.52204 21.0393 4.4611 21.0041 4.40051 20.9682L9.99997 11.5001L4.58331 21.074Z"
            fill="#0080FF"
          />
          <path
            d="M4.41725 20.978C4.3566 20.9423 4.29629 20.9059 4.23633 20.8691L10.0002 11.5001L4.41725 20.978Z"
            fill="#007BFF"
          />
          <path
            d="M4.25242 20.8791C4.1924 20.8423 4.13273 20.805 4.07343 20.767L9.9999 11.5001L4.25242 20.8791Z"
            fill="#0077FF"
          />
          <path
            d="M4.08937 20.7774C4.02999 20.7395 3.97099 20.7012 3.91235 20.6622L9.99966 11.5001L4.08937 20.7774Z"
            fill="#0072FF"
          />
          <path
            d="M3.92864 20.6728C3.86993 20.634 3.81161 20.5945 3.75366 20.5546L9.99994 11.5001L3.92864 20.6728Z"
            fill="#006FFF"
          />
          <path
            d="M3.7695 20.5655C3.71149 20.5256 3.65386 20.4852 3.59662 20.4442L9.99997 11.5001L3.7695 20.5655Z"
            fill="#006AFF"
          />
          <path
            d="M3.61227 20.4553C3.55496 20.4145 3.49804 20.373 3.44153 20.3311L10 11.5001L3.61227 20.4553Z"
            fill="#0066FF"
          />
          <path
            d="M3.45694 20.3425C3.40035 20.3006 3.34416 20.2582 3.28839 20.2153L9.99998 11.5001L3.45694 20.3425Z"
            fill="#0062FF"
          />
          <path
            d="M3.30357 20.227C3.24772 20.1841 3.19228 20.1407 3.13727 20.0968L9.99994 11.5001L3.30357 20.227Z"
            fill="#005EFF"
          />
          <path
            d="M3.15228 20.1088C3.09719 20.0649 3.04252 20.0206 2.98828 19.9757L9.99994 11.5001L3.15228 20.1088Z"
            fill="#0059FF"
          />
          <path
            d="M3.00315 19.9879C2.94883 19.9432 2.89494 19.8979 2.84149 19.8521L10 11.5001L3.00315 19.9879Z"
            fill="#0055FF"
          />
          <path
            d="M2.85604 19.8645C2.80251 19.8188 2.74942 19.7726 2.69678 19.7258L9.99996 11.5001L2.85604 19.8645Z"
            fill="#0051FF"
          />
          <path
            d="M2.71114 19.7386C2.65841 19.6919 2.60614 19.6448 2.55432 19.5971L9.99995 11.5001L2.71114 19.7386Z"
            fill="#004DFF"
          />
          <path
            d="M2.56814 19.6101C2.51624 19.5626 2.4648 19.5145 2.41382 19.466L9.99963 11.5001L2.56814 19.6101Z"
            fill="#0048FF"
          />
          <path
            d="M2.42809 19.4792C2.37703 19.4307 2.32643 19.3818 2.27631 19.3324L9.99998 11.5001L2.42809 19.4792Z"
            fill="#0044FF"
          />
          <path
            d="M2.28995 19.3458C2.23974 19.2965 2.19 19.2467 2.14075 19.1964L9.99994 11.5001L2.28995 19.3458Z"
            fill="#0040FF"
          />
          <path
            d="M2.15426 19.2101C2.10492 19.1599 2.05606 19.1092 2.00769 19.058L10 11.5001L2.15426 19.2101Z"
            fill="#003CFF"
          />
          <path
            d="M2.0206 19.072C1.97214 19.0209 1.92418 18.9694 1.87671 18.9174L9.99971 11.5001L2.0206 19.072Z"
            fill="#0037FF"
          />
          <path
            d="M1.88989 18.9316C1.84233 18.8797 1.79527 18.8273 1.74872 18.7745L9.99994 11.5001L1.88989 18.9316Z"
            fill="#0033FF"
          />
          <path
            d="M1.7617 18.7889C1.71505 18.7362 1.66892 18.683 1.62329 18.6294L10.0002 11.5001L1.7617 18.7889Z"
            fill="#002FFF"
          />
          <path
            d="M1.63554 18.644C1.58982 18.5905 1.54462 18.5365 1.49994 18.4821L10 11.5001L1.63554 18.644Z"
            fill="#002BFF"
          />
          <path
            d="M1.51209 18.4969C1.46731 18.4426 1.42306 18.3879 1.37933 18.3327L9.99996 11.5001L1.51209 18.4969Z"
            fill="#0026FF"
          />
          <path
            d="M1.39128 18.3477C1.34746 18.2926 1.30417 18.2371 1.26141 18.1812L9.99997 11.5001L1.39128 18.3477Z"
            fill="#0022FF"
          />
          <path
            d="M1.27306 18.1964C1.23021 18.1406 1.18789 18.0843 1.14612 18.0277L9.99995 11.5001L1.27306 18.1964Z"
            fill="#001EFF"
          />
          <path
            d="M1.15743 18.0431C1.11555 17.9865 1.07423 17.9295 1.03345 17.8722L9.99985 11.5001L1.15743 18.0431Z"
            fill="#001AFF"
          />
          <path
            d="M1.04474 17.8878C1.00387 17.8305 0.963538 17.7728 0.923767 17.7147L10 11.5001L1.04474 17.8878Z"
            fill="#0015FF"
          />
          <path
            d="M0.934589 17.7305C0.894716 17.6725 0.855402 17.6141 0.81665 17.5553L9.99998 11.5001L0.934589 17.7305Z"
            fill="#0011FF"
          />
          <path
            d="M0.827204 17.5714C0.788351 17.5127 0.750061 17.4536 0.712341 17.3942L9.99995 11.5001L0.827204 17.5714Z"
            fill="#000DFF"
          />
          <path
            d="M0.722715 17.4104C0.684892 17.351 0.647639 17.2913 0.610962 17.2312L10 11.5001L0.722715 17.4104Z"
            fill="#0009FF"
          />
          <path
            d="M0.620877 17.2475C0.584095 17.1875 0.547891 17.1272 0.512268 17.0664L9.99991 11.5001L0.620877 17.2475Z"
            fill="#0004FF"
          />
          <path
            d="M0.522058 17.083C0.486329 17.0223 0.451184 16.9613 0.416626 16.9L9.99998 11.5001L0.522058 17.083Z"
            fill="#0000FF"
          />
          <path
            d="M0.426074 16.9167C0.39141 16.8555 0.357334 16.7939 0.323853 16.7319L9.99998 11.5001L0.426074 16.9167Z"
            fill="#0400FF"
          />
          <path
            d="M0.33299 16.7488C0.2994 16.6869 0.266405 16.6248 0.234009 16.5623L9.99998 11.5001L0.33299 16.7488Z"
            fill="#0900FF"
          />
          <path
            d="M0.242805 16.5793C0.2103 16.5169 0.178395 16.4541 0.147095 16.3911L9.99992 11.5001L0.242805 16.5793Z"
            fill="#0D00FF"
          />
          <path
            d="M0.155704 16.4082C0.124293 16.3452 0.0934885 16.2819 0.0632935 16.2183L9.99998 11.5001L0.155704 16.4082Z"
            fill="#1100FF"
          />
          <path
            d="M0.0715648 16.2357C0.0412588 16.1721 0.0115635 16.1083 -0.0175171 16.0442L10 11.5001L0.0715648 16.2357Z"
            fill="#1500FF"
          />
          <path
            d="M-0.00954912 16.0617C-0.0387416 15.9976 -0.0673185 15.9333 -0.0952759 15.8687L10 11.5001L-0.00954912 16.0617Z"
            fill="#1A00FF"
          />
          <path
            d="M-0.0876985 15.8863C-0.115769 15.8217 -0.143218 15.7569 -0.170044 15.6918L9.99996 11.5001L-0.0876985 15.8863Z"
            fill="#1E00FF"
          />
          <path
            d="M-0.162699 15.7096C-0.189638 15.6445 -0.215953 15.5792 -0.241638 15.5137L9.99997 11.5001L-0.162699 15.7096Z"
            fill="#2200FF"
          />
          <path
            d="M-0.234611 15.5316C-0.260411 15.4661 -0.285582 15.4003 -0.31012 15.3344L9.99998 11.5001L-0.234611 15.5316Z"
            fill="#2600FF"
          />
          <path
            d="M-0.303433 15.3523C-0.328086 15.2864 -0.352106 15.2202 -0.375488 15.1538L9.99996 11.5001L-0.303433 15.3523Z"
            fill="#2B00FF"
          />
          <path
            d="M-0.369042 15.1719C-0.392541 15.1056 -0.415402 15.039 -0.437622 14.9722L10 11.5001L-0.369042 15.1719Z"
            fill="#2F00FF"
          />
          <path
            d="M-0.431559 14.9904C-0.453896 14.9237 -0.475592 14.8567 -0.496643 14.7895L10 11.5001L-0.431559 14.9904Z"
            fill="#3300FF"
          />
          <path
            d="M-0.490923 14.8078C-0.512091 14.7407 -0.532615 14.6733 -0.55249 14.6058L9.99996 11.5001L-0.490923 14.8078Z"
            fill="#3700FF"
          />
          <path
            d="M-0.54707 14.6242C-0.567064 14.5567 -0.586409 14.489 -0.605103 14.4212L9.99995 11.5001L-0.54707 14.6242Z"
            fill="#3C00FF"
          />
          <path
            d="M-0.6 14.4397C-0.618813 14.3718 -0.636973 14.3038 -0.65448 14.2357L9.99993 11.5001L-0.6 14.4397Z"
            fill="#4000FF"
          />
          <path
            d="M-0.649651 14.2542C-0.667277 14.1861 -0.684248 14.1178 -0.700562 14.0493L9.99997 11.5001L-0.649651 14.2542Z"
            fill="#4400FF"
          />
          <path
            d="M-0.696082 14.068C-0.712516 13.9995 -0.728292 13.9309 -0.743408 13.8622L9.99998 11.5001L-0.696082 14.068Z"
            fill="#4800FF"
          />
          <path
            d="M-0.739232 13.8809C-0.754469 13.8122 -0.769045 13.7433 -0.782959 13.6743L10 11.5001L-0.739232 13.8809Z"
            fill="#4D00FF"
          />
          <path
            d="M-0.779466 13.6931C-0.7935 13.6241 -0.806872 13.555 -0.81958 13.4858L9.9997 11.5001L-0.779466 13.6931Z"
            fill="#5100FF"
          />
          <path
            d="M-0.815805 13.5047C-0.828634 13.4354 -0.840798 13.3661 -0.852295 13.2966L10 11.5001L-0.815805 13.5047Z"
            fill="#5500FF"
          />
          <path
            d="M-0.849165 13.3156C-0.860784 13.2462 -0.871735 13.1766 -0.882019 13.107L9.99998 11.5001L-0.849165 13.3156Z"
            fill="#5900FF"
          />
          <path
            d="M-0.879239 13.126C-0.889644 13.0563 -0.899381 12.9866 -0.908447 12.9168L9.99993 11.5001L-0.879239 13.126Z"
            fill="#5E00FF"
          />
          <path
            d="M-0.905904 12.9358C-0.915092 12.8661 -0.923611 12.7962 -0.931458 12.7262L9.99998 11.5001L-0.905904 12.9358Z"
            fill="#6200FF"
          />
          <path
            d="M-0.929342 12.7453C-0.937311 12.6754 -0.944608 12.6053 -0.951233 12.5353L9.99994 11.5001L-0.929342 12.7453Z"
            fill="#6600FF"
          />
          <path
            d="M-0.949429 12.5544C-0.956176 12.4843 -0.962251 12.4142 -0.967651 12.344L9.99993 11.5001L-0.949429 12.5544Z"
            fill="#6A00FF"
          />
          <path
            d="M-0.966165 12.3631C-0.971689 12.2929 -0.976538 12.2227 -0.980713 12.1524L9.99992 11.5001L-0.966165 12.3631Z"
            fill="#6F00FF"
          />
          <path
            d="M-0.979549 12.1716C-0.983847 12.1013 -0.98747 12.031 -0.990417 11.9607L9.99993 11.5001L-0.979549 12.1716Z"
            fill="#7300FF"
          />
          <path
            d="M-0.98964 11.9799C-0.992711 11.9095 -0.995106 11.8392 -0.996826 11.7688L9.99989 11.5001L-0.98964 11.9799Z"
            fill="#7700FF"
          />
          <path
            d="M-0.996254 11.788C-0.998097 11.7176 -0.999264 11.6472 -0.999756 11.5769L9.99997 11.5001L-0.996254 11.788Z"
            fill="#7B00FF"
          />
          <path
            d="M-0.999581 11.596C-1.0002 11.5256 -1.00013 11.4552 -0.999397 11.3848L10 11.5L-0.999581 11.596Z"
            fill="#8000FF"
          />
          <path
            d="M-0.999634 11.404C-0.999019 11.3336 -0.997729 11.2632 -0.995764 11.1929L9.99994 11.5L-0.999634 11.404Z"
            fill="#8400FF"
          />
          <path
            d="M-0.996216 11.2124C-0.994373 11.142 -0.991855 11.0717 -0.988662 11.0013L10 11.5003L-0.996216 11.2124Z"
            fill="#8800FF"
          />
          <path
            d="M-0.989502 11.0203C-0.986431 10.9499 -0.982686 10.8796 -0.978266 10.8094L10 11.5001L-0.989502 11.0203Z"
            fill="#8C00FF"
          />
          <path
            d="M-0.979553 10.8285C-0.975256 10.7582 -0.970284 10.688 -0.964638 10.6179L9.99993 11.5L-0.979553 10.8285Z"
            fill="#9100FF"
          />
          <path
            d="M-0.966125 10.6371C-0.960602 10.5669 -0.954406 10.4968 -0.947536 10.4267L9.99996 11.5001L-0.966125 10.6371Z"
            fill="#9500FF"
          />
          <path
            d="M-0.949341 10.446C-0.942594 10.3759 -0.935174 10.3059 -0.927083 10.236L10 11.5003L-0.949341 10.446Z"
            fill="#9900FF"
          />
          <path
            d="M-0.92926 10.2549C-0.921291 10.1849 -0.912651 10.1151 -0.903341 10.0453L10 11.5001L-0.92926 10.2549Z"
            fill="#9D00FF"
          />
          <path
            d="M-0.905945 10.0643C-0.896756 9.99447 -0.886898 9.92477 -0.876371 9.85516L9.99994 11.5001L-0.905945 10.0643Z"
            fill="#A200FF"
          />
          <path
            d="M-0.879211 9.87414C-0.868806 9.80452 -0.857733 9.735 -0.845993 9.66559L9.99996 11.5L-0.879211 9.87414Z"
            fill="#A600FF"
          />
          <path
            d="M-0.849182 9.68451C-0.837563 9.61507 -0.825279 9.54576 -0.812329 9.47656L9.99996 11.5L-0.849182 9.68451Z"
            fill="#AA00FF"
          />
          <path
            d="M-0.815857 9.49547C-0.803028 9.42626 -0.789536 9.35717 -0.775381 9.28821L9.99994 11.5001L-0.815857 9.49547Z"
            fill="#AE00FF"
          />
          <path
            d="M-0.779297 9.30699C-0.765262 9.23801 -0.750566 9.16916 -0.73521 9.10046L9.99987 11.5L-0.779297 9.30699Z"
            fill="#B300FF"
          />
          <path
            d="M-0.739319 9.11924C-0.724082 9.05051 -0.708187 8.98193 -0.691634 8.91351L9.99993 11.5001L-0.739319 9.11924Z"
            fill="#B700FF"
          />
          <path
            d="M-0.696106 8.93216C-0.679672 8.86371 -0.662582 8.79542 -0.644838 8.72729L9.99996 11.5001L-0.696106 8.93216Z"
            fill="#BB00FF"
          />
          <path
            d="M-0.649658 8.74587C-0.632033 8.67772 -0.613753 8.60973 -0.594823 8.54193L9.99996 11.5001L-0.649658 8.74587Z"
            fill="#BF00FF"
          />
          <path
            d="M-0.599976 8.56049C-0.581163 8.49266 -0.5617 8.42501 -0.541589 8.35754L9.99996 11.5001L-0.599976 8.56049Z"
            fill="#C400FF"
          />
          <path
            d="M-0.547058 8.37591C-0.527065 8.30841 -0.506424 8.24111 -0.485138 8.17401L9.99996 11.5001L-0.547058 8.37591Z"
            fill="#C800FF"
          />
          <path
            d="M-0.490906 8.1923C-0.469737 8.12517 -0.447925 8.05823 -0.425472 7.99152L9.99998 11.5001L-0.490906 8.1923Z"
            fill="#CC00FF"
          />
          <path
            d="M-0.431641 8.00974C-0.409304 7.94298 -0.386327 7.87644 -0.362713 7.81012L9.99991 11.5001L-0.431641 8.00974Z"
            fill="#D000FF"
          />
          <path
            d="M-0.36908 7.8282C-0.345581 7.76185 -0.321446 7.69572 -0.296678 7.62982L9.99997 11.5001L-0.36908 7.8282Z"
            fill="#D500FF"
          />
          <path
            d="M-0.303406 7.64771C-0.278753 7.58177 -0.253467 7.51607 -0.227553 7.45062L9.99998 11.5L-0.303406 7.64771Z"
            fill="#D900FF"
          />
          <path
            d="M-0.234619 7.46856C-0.208819 7.40307 -0.182391 7.33782 -0.155338 7.27283L9.99997 11.5001L-0.234619 7.46856Z"
            fill="#DD00FF"
          />
          <path
            d="M-0.162598 7.29088C-0.135658 7.22584 -0.108095 7.16107 -0.0799124 7.09656L10.0001 11.5004L-0.162598 7.29088Z"
            fill="#E100FF"
          />
          <path
            d="M-0.0874023 7.11381C-0.0593323 7.04925 -0.0306431 6.98497 -0.00133891 6.92096L10.0003 11.5001L-0.0874023 7.11381Z"
            fill="#E600FF"
          />
          <path
            d="M-0.00952148 6.93875C0.019671 6.8747 0.0494777 6.81092 0.0798946 6.74744L10 11.5004L-0.00952148 6.93875Z"
            fill="#EA00FF"
          />
          <path
            d="M0.0715332 6.76444C0.101839 6.7009 0.132754 6.63765 0.164275 6.57471L9.99997 11.5001L0.0715332 6.76444Z"
            fill="#EE00FF"
          />
          <path
            d="M0.155762 6.59189C0.187172 6.52889 0.219186 6.46619 0.2518 6.40381L10 11.5001L0.155762 6.59189Z"
            fill="#F200FF"
          />
          <path
            d="M0.24292 6.42087C0.275425 6.35843 0.308528 6.2963 0.342226 6.2345L10 11.5001L0.24292 6.42087Z"
            fill="#F700FF"
          />
          <path
            d="M0.333008 6.25133C0.366598 6.18946 0.40078 6.12792 0.435552 6.06671L9.99999 11.5001L0.333008 6.25133Z"
            fill="#FB00FF"
          />
          <path
            d="M0.426086 6.08343C0.460751 6.02216 0.496002 5.96123 0.531837 5.90063L10 11.5001L0.426086 6.08343Z"
            fill="#FF00FF"
          />
          <path
            d="M0.522217 5.91725C0.557945 5.8566 0.594255 5.79629 0.631141 5.73633L10.0001 11.5002L0.522217 5.91725Z"
            fill="#FF00FB"
          />
          <path
            d="M0.620911 5.75285C0.657692 5.69282 0.695049 5.63316 0.732976 5.57385L9.99995 11.5003L0.620911 5.75285Z"
            fill="#FF00F7"
          />
          <path
            d="M0.722656 5.58979C0.76048 5.53042 0.798872 5.47141 0.837828 5.41278L9.99996 11.5001L0.722656 5.58979Z"
            fill="#FF00F2"
          />
          <path
            d="M0.827271 5.4287C0.866124 5.37 0.905541 5.31167 0.945514 5.25372L10 11.5L0.827271 5.4287Z"
            fill="#FF00EE"
          />
          <path
            d="M0.934631 5.26956C0.974504 5.21155 1.01493 5.15392 1.05591 5.09668L10 11.5L0.934631 5.26956Z"
            fill="#FF00EA"
          />
          <path
            d="M1.04474 5.11233C1.08562 5.05502 1.12705 4.9981 1.16902 4.94159L10 11.5001L1.04474 5.11233Z"
            fill="#FF00E6"
          />
          <path
            d="M1.15759 4.95706C1.19947 4.90047 1.24188 4.84429 1.28483 4.78851L10 11.5001L1.15759 4.95706Z"
            fill="#FF00E1"
          />
          <path
            d="M1.27313 4.80363C1.31599 4.74778 1.35938 4.69234 1.40329 4.63733L10 11.5L1.27313 4.80363Z"
            fill="#FF00DD"
          />
          <path
            d="M1.3913 4.65235C1.43512 4.59725 1.47947 4.54258 1.52434 4.48834L9.99998 11.5L1.3913 4.65235Z"
            fill="#FF00D9"
          />
          <path
            d="M1.51215 4.50321C1.55692 4.44889 1.60222 4.395 1.64803 4.34155L10 11.5001L1.51215 4.50321Z"
            fill="#FF00D5"
          />
          <path
            d="M1.63556 4.3561C1.68128 4.30257 1.72751 4.24948 1.77425 4.19684L10 11.5L1.63556 4.3561Z"
            fill="#FF00D0"
          />
          <path
            d="M1.76123 4.21126C1.80788 4.15854 1.85503 4.10626 1.90268 4.05444L9.99974 11.5001L1.76123 4.21126Z"
            fill="#FF00CC"
          />
          <path
            d="M1.88989 4.06863C1.93745 4.01673 1.98551 3.96529 2.03405 3.91431L9.99994 11.5001L1.88989 4.06863Z"
            fill="#FF00C8"
          />
          <path
            d="M2.02087 3.92815C2.06933 3.87709 2.11828 3.82649 2.16771 3.77637L9.99999 11.5001L2.02087 3.92815Z"
            fill="#FF00C4"
          />
          <path
            d="M2.15424 3.79007C2.20358 3.73986 2.2534 3.69012 2.30369 3.64087L9.99999 11.5001L2.15424 3.79007Z"
            fill="#FF00BF"
          />
          <path
            d="M2.28998 3.65432C2.34019 3.60498 2.39087 3.55612 2.44202 3.50775L9.99998 11.5001L2.28998 3.65432Z"
            fill="#FF00BB"
          />
          <path
            d="M2.4281 3.52097C2.47916 3.47251 2.53069 3.42454 2.58267 3.37708L10 11.5001L2.4281 3.52097Z"
            fill="#FF00B7"
          />
          <path
            d="M2.5686 3.39001C2.6205 3.34245 2.67286 3.29539 2.72567 3.24884L10.0001 11.5001L2.5686 3.39001Z"
            fill="#FF00B3"
          />
          <path
            d="M2.71118 3.2617C2.7639 3.21505 2.81707 3.16892 2.87068 3.12329L10 11.5002L2.71118 3.2617Z"
            fill="#FF00AE"
          />
          <path
            d="M2.85608 3.1356C2.90961 3.08989 2.96358 3.04468 3.01797 3L10 11.5001L2.85608 3.1356Z"
            fill="#FF00AA"
          />
          <path
            d="M3.00311 3.01221C3.05743 2.96744 3.11218 2.92318 3.16735 2.87946L9.99997 11.5001L3.00311 3.01221Z"
            fill="#FF00A6"
          />
          <path
            d="M3.15228 2.89135C3.20737 2.84752 3.26289 2.80423 3.31881 2.76147L9.99994 11.5L3.15228 2.89135Z"
            fill="#FF00A2"
          />
          <path
            d="M3.30359 2.77312C3.35944 2.73027 3.4157 2.68795 3.47236 2.64618L9.99996 11.5L3.30359 2.77312Z"
            fill="#FF009D"
          />
          <path
            d="M3.45691 2.65779C3.5135 2.61592 3.57049 2.57459 3.62787 2.53381L9.99996 11.5002L3.45691 2.65779Z"
            fill="#FF0099"
          />
          <path
            d="M3.61224 2.54481C3.66955 2.50393 3.72725 2.4636 3.78534 2.42383L9.99997 11.5001L3.61224 2.54481Z"
            fill="#FF0095"
          />
          <path
            d="M3.76953 2.43465C3.82755 2.39478 3.88594 2.35546 3.94471 2.31671L10 11.5L3.76953 2.43465Z"
            fill="#FF0091"
          />
          <path
            d="M3.92847 2.32727C3.98717 2.28841 4.04624 2.25012 4.10568 2.2124L9.99977 11.5L3.92847 2.32727Z"
            fill="#FF008C"
          />
          <path
            d="M4.0896 2.22278C4.14897 2.18495 4.2087 2.1477 4.26879 2.11102L9.99989 11.5001L4.0896 2.22278Z"
            fill="#FF0088"
          />
          <path
            d="M4.2525 2.121C4.31252 2.08422 4.3729 2.04801 4.43361 2.01239L9.99998 11.5L4.2525 2.121Z"
            fill="#FF0084"
          />
          <path
            d="M4.41705 2.02212C4.47771 1.98639 4.5387 1.95124 4.60003 1.91669L9.99997 11.5L4.41705 2.02212Z"
            fill="#FF0080"
          />
          <path
            d="M4.58331 1.92614C4.64458 1.89147 4.70618 1.8574 4.76811 1.82391L9.99997 11.5001L4.58331 1.92614Z"
            fill="#FF007B"
          />
          <path
            d="M4.75122 1.83305C4.81309 1.79946 4.87527 1.76647 4.93777 1.73407L9.99997 11.5L4.75122 1.83305Z"
            fill="#FF0077"
          />
          <path
            d="M4.92072 1.74287C4.98316 1.71036 5.04591 1.67846 5.10896 1.64716L9.99995 11.5L4.92072 1.74287Z"
            fill="#FF0073"
          />
          <path
            d="M5.09186 1.65577C5.15486 1.62435 5.21816 1.59355 5.28175 1.56335L10 11.5L5.09186 1.65577Z"
            fill="#FF006F"
          />
          <path
            d="M5.26434 1.57163C5.32788 1.54132 5.39171 1.51162 5.45582 1.48254L9.99996 11.5001L5.26434 1.57163Z"
            fill="#FF006A"
          />
          <path
            d="M5.43835 1.49051C5.50241 1.46132 5.56675 1.43274 5.63135 1.40479L9.99998 11.5001L5.43835 1.49051Z"
            fill="#FF0066"
          />
          <path
            d="M5.61401 1.41236C5.67857 1.38429 5.7434 1.35684 5.80848 1.33002L10.0003 11.5L5.61401 1.41236Z"
            fill="#FF0062"
          />
          <path
            d="M5.79047 1.33742C5.8555 1.31048 5.9208 1.28417 5.98634 1.25848L9.99998 11.5001L5.79047 1.33742Z"
            fill="#FF005E"
          />
          <path
            d="M5.96851 1.26551C6.034 1.23971 6.09975 1.21454 6.16573 1.19L10 11.5001L5.96851 1.26551Z"
            fill="#FF0059"
          />
          <path
            d="M6.14771 1.19663C6.21364 1.17197 6.27982 1.14796 6.34621 1.12457L9.99998 11.5L6.14771 1.19663Z"
            fill="#FF0055"
          />
          <path
            d="M6.32837 1.13102C6.39473 1.10752 6.46131 1.08466 6.52811 1.06244L10.0002 11.5001L6.32837 1.13102Z"
            fill="#FF0051"
          />
          <path
            d="M6.50928 1.0685C6.57603 1.04616 6.64301 1.02447 6.71018 1.00342L9.99963 11.5001L6.50928 1.0685Z"
            fill="#FF004D"
          />
          <path
            d="M6.69189 1.00914C6.75903 0.98797 6.82637 0.967446 6.8939 0.947571L9.99966 11.5L6.69189 1.00914Z"
            fill="#FF0048"
          />
          <path
            d="M6.87579 0.952991C6.94329 0.932997 7.01098 0.913652 7.07884 0.894958L9.99996 11.5L6.87579 0.952991Z"
            fill="#FF0044"
          />
          <path
            d="M7.06036 0.900427C7.1282 0.881615 7.19621 0.863454 7.2644 0.845947L9.99998 11.5004L7.06036 0.900427Z"
            fill="#FF0040"
          />
          <path
            d="M7.24579 0.85041C7.31394 0.832784 7.38226 0.815814 7.45074 0.7995L9.99997 11.5L7.24579 0.85041Z"
            fill="#FF003C"
          />
          <path
            d="M7.43213 0.803979C7.50058 0.787545 7.56919 0.771769 7.63794 0.756653L10 11.5001L7.43213 0.803979Z"
            fill="#FF0037"
          />
          <path
            d="M7.61914 0.760829C7.68787 0.745593 7.75674 0.731016 7.82575 0.717102L9.99998 11.5001L7.61914 0.760829Z"
            fill="#FF0033"
          />
          <path
            d="M7.80695 0.720962C7.87593 0.706927 7.94504 0.693555 8.01428 0.680847L9.99999 11.5001L7.80695 0.720962Z"
            fill="#FF002F"
          />
          <path
            d="M7.99536 0.684256C8.06458 0.671427 8.13392 0.659264 8.20337 0.647766L9.99995 11.5001L7.99536 0.684256Z"
            fill="#FF002B"
          />
          <path
            d="M8.18445 0.650957C8.25388 0.639338 8.32342 0.628387 8.39306 0.618103L9.99997 11.5001L8.18445 0.650957Z"
            fill="#FF0026"
          />
          <path
            d="M8.37408 0.620822C8.44371 0.610417 8.51343 0.60068 8.58324 0.591614L9.99999 11.5L8.37408 0.620822Z"
            fill="#FF0022"
          />
          <path
            d="M8.56421 0.594157C8.634 0.584969 8.70388 0.57645 8.77384 0.568604L10 11.5001L8.56421 0.594157Z"
            fill="#FF001E"
          />
          <path
            d="M8.75439 0.571086C8.82434 0.563117 8.89436 0.555819 8.96444 0.549194L9.99963 11.5004L8.75439 0.571086Z"
            fill="#FF001A"
          />
          <path
            d="M8.94568 0.550693C9.01575 0.543946 9.08588 0.537871 9.15607 0.532471L9.99998 11.5001L8.94568 0.550693Z"
            fill="#FF0015"
          />
          <path
            d="M9.1369 0.534201C9.20708 0.528677 9.27731 0.523828 9.34758 0.519653L9.99995 11.5003L9.1369 0.534201Z"
            fill="#FF0011"
          />
          <path
            d="M9.32843 0.520573C9.39869 0.516275 9.469 0.512652 9.53933 0.509705L9.99996 11.5001L9.32843 0.520573Z"
            fill="#FF000D"
          />
          <path
            d="M9.5202 0.510726C9.59053 0.507655 9.66089 0.50526 9.73126 0.50354L10 11.5003L9.5202 0.510726Z"
            fill="#FF0009"
          />
          <path
            d="M9.71216 0.503807C9.78253 0.501964 9.85292 0.500797 9.92331 0.500305L10.0001 11.5L9.71216 0.503807Z"
            fill="#FF0004"
          />
          <path
            d="M10 22.5C16.0751 22.5 21 17.5751 21 11.5C21 5.42487 16.0751 0.5 10 0.5C3.92487 0.5 -1 5.42487 -1 11.5C-1 17.5751 3.92487 22.5 10 22.5Z"
            fill="url(#paint0_radial_619_4710)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_619_4710"
          x="1.40002"
          y="0.5"
          width="17.1859"
          height="19.0508"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_619_4710" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_619_4710"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_619_4710"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10 11.5) scale(11 11)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default GocciaFullColor
